module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.extra) ? _c('article', {
    staticClass: "extra article"
  }, [_c('router-link', {
    staticClass: "image",
    style: ({
      backgroundImage: 'url(' + _vm.featuredImage + ')'
    }),
    attrs: {
      "to": {
        name: 'Post',
        params: {
          slug: _vm.extra.slug
        }
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Post',
        params: {
          slug: _vm.extra.slug
        }
      }
    }
  }, [_c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.extra.title)
    }
  })]), _vm._v(" "), _c('p', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.extra.excerpt)
    }
  }), _vm._v(" "), _c('router-link', {
    staticClass: "more-link",
    attrs: {
      "to": {
        name: 'Post',
        params: {
          slug: _vm.extra.slug
        }
      }
    }
  }, [_vm._v("More")])], 1), _vm._v(" "), _c('div', {
    staticClass: "readModule"
  }, [_c('router-link', {
    staticClass: "readButton",
    attrs: {
      "tag": "button",
      "to": {
        name: 'Post',
        params: {
          slug: _vm.extra.slug
        }
      }
    }
  }, [_c('span', [_vm._v("Read more")])])], 1)], 1)], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fd68e760"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/ExtraModule.vue
// module id = 805
// module chunks = 1